import React, { useState, useEffect } from 'react';
import {
    Card,
    Col,
    Form,
    Row,
    Button,
    Alert,
    Modal,
    OverlayTrigger,
    Tooltip,
    Offcanvas,
    Badge
} from 'react-bootstrap';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import useAdvanceTable from 'hooks/useAdvanceTable';
import moment from 'moment';
import axios from 'helpers/api';
import Select from "react-select";
import DatePicker from 'react-datepicker';
import { toast } from 'react-toastify';
import CommonBreadCrumb from 'components/commonbreadcrumb/CommonBreadCrumb';
import AddNotesModal from './AddNotesModal';
import AddHoldOrderDetailModal from './AddHoldOrderDetailModal';
import SetMastersDetails from 'components/common/SetMastersDetails';
import RemoveMasters from 'components/common/RemoveMasters';
import paths from 'routes/paths';
import ThemedSelect from 'components/commonbreadcrumb/ThemedSelect';
import HoldRxGrid from './HoldRxGrid';
import ShimmerUI from 'components/ShimmerUI/PatientShimmer';
import { storeList, getStoredStoreId, setStoredStoreId } from 'components/common/StoreList';
import { useAppContext } from 'providers/AppProvider';
import { useSearchParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconItem from 'components/common/icon/IconItem';

const IndexHold = () => {
    const getActiveHoldReasons = () =>
        JSON.parse(localStorage.getItem('activeHoldReasonsData') || '[]');
    const getAllHoldReasons = () =>
        JSON.parse(localStorage.getItem('holdReasonsData') || '[]');
    const buildReasonObj = (reasons = getAllHoldReasons()) => {
        return reasons.reduce((acc, reason) => {
            acc[reason.id] = reason.reason;
            return acc;
        }, {});
    };

    const savedStoreId = getStoredStoreId();
    const [dateFilterType, setDateFilterType] = useState('hold_date');
    const [filters, setFilters] = useState({
        group: '',
        facility: '',
        holdreason: '',
        holdstatus: '1',
        holdtype: '',
        holdsearch: '',
        store: savedStoreId,
        delivery_cycle_date: '',
        hold_by_date: ''
    });
    const storeOptionsMaster = [
        { key: 'All Stores', value: '' },
        ...storeList
    ];
    const initialStoreOption = storeOptionsMaster.find(opt => String(opt.value) === String(savedStoreId)) || '';
    const [selectedStoreValue, setSelectedStoreValue] = useState(initialStoreOption);
    const [searchParams] = useSearchParams();
    const fromParam = searchParams.get('from');
    const toParam = searchParams.get('to');
    const [startDate, setStartDate] = useState(
        fromParam
            ? moment(fromParam, 'MM/DD/YYYY').toDate()
            : moment().subtract(31, 'days').toDate()
    );
    const [endDate, setEndDate] = useState(
        toParam
            ? moment(toParam, 'MM/DD/YYYY').toDate()
            : moment().add(7, 'days').toDate()
    );
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [options, setOptions] = useState([]);
    const [reasonOptions, setReasonsOptions] = useState([
        { key: 'All Reasons', value: '' },
        ...getActiveHoldReasons()
    ]);
    const [holdreasonsresults, setReasonsResults] = useState(
        getActiveHoldReasons()
    );
    const [groupOptions, setGroupOptions] = useState([]);
    const [reasonObj, setReasonObj] = useState(buildReasonObj());
    const [showModal, setShowModal] = useState(false);
    const [holdId, setHoldId] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [holdNotes, setHoldNotes] = useState([]);
    const [, setFacilitiesObj] = useState([]);
    const facilityList = JSON.parse(localStorage.getItem('facilitiesData')) || [];
    const [startDateError, setStartDateError] = useState('');
    const [endDateError, setEndDateError] = useState('');
    const [facilityobj, setFacilityObj] = useState({});
    const [showRxModal, setShowRxModal] = useState(false);
    const [showFilterDrawer, setShowFilterDrawer] = useState(false);
    const [selectedGroupValue, setSelectedGroupValue] = useState({ key: 'All Groups', value: '' });
    const [selectedFacilityValue, setSelectedFacilityValue] = useState({ key: 'All Facilities', value: '' });
    const facilityResultsNew = JSON.parse(localStorage.getItem('facilitiesData')) || [];
    const [showCreateOrderModal, setShowCreateOrderModal] = useState(false);
    const [createOrderInitialData, setCreateOrderInitialData] = useState(null);

    const handleAddOrderFromHold = item => {
        const pId = item.patient_id;
        setCreateOrderInitialData({
            patient_id: pId,
            patient_name: item.patient,
            patient_firstname: item.patient_firstname,
            patient_lastname: item.patient_lastname,
            facility_id: item.facility_id,
            facility_name: item.facility,
            drug: item.drug,
            rx_number: item.rx_id || item.pharmacy_order_id,
            order_type: 4
        });
        setShowCreateOrderModal(true);
    };

    const activeFilterCount = [
        filters.group,
        filters.facility,
        filters.holdreason,
        filters.holdstatus !== '1' ? filters.holdstatus : '',
        filters.holdtype,
        filters.holdsearch,
        filters.store !== savedStoreId ? filters.store : '',
        filters.delivery_cycle_date,
        filters.hold_by_date
    ].filter(Boolean).length;

    const handleResetFilters = () => {
        const defaultGroup = { key: 'All Groups', value: '' };
        const defaultFacility = { key: 'All Facilities', value: '' };
        setSelectedGroupValue(defaultGroup);
        setSelectedFacilityValue(defaultFacility);
        setSelectedStoreValue(initialStoreOption);
        setOptions([
            defaultFacility,
            ...facilityResultsNew
        ]);
        setFilters({
            group: '',
            facility: '',
            holdreason: '',
            holdstatus: '1',
            holdtype: '',
            holdsearch: '',
            store: savedStoreId,
            delivery_cycle_date: '',
            hold_by_date: ''
        });
    };
    const [storeOptions] = useState([
        { key: 'All Stores', value: '' },
        ...storeList
    ]);
    const columns = [
        {
            accessorKey: 'facility',
            header: 'Facility',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'delivery_cycle_date',
            header: 'Delivery/Cycle Date',
            meta: {
                headerProps: { className: 'text-900 ' }
            },
            sortingFn: (rowA, rowB) => {
                const a = moment(rowA.original.delivery_cycle_date, 'MM/DD/YY');
                const b = moment(rowB.original.delivery_cycle_date, 'MM/DD/YY');
                return a.isBefore(b) ? -1 : a.isAfter(b) ? 1 : 0;
            }
        },
        {
            accessorKey: 'patient',
            header: 'Patient',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'rx_id',
            header: 'Rx',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'drug',
            header: 'Drug',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'reason',
            header: 'Reason',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'status',
            header: 'Status',
            meta: {
                headerProps: { className: 'text-900 text-center' },
                cellProps: { className: 'text-center' }
            },
            cell: ({ row: { original } }) => (
                <div className="d-flex justify-content-center">
                    <Form.Select
                        className="form-select form-select-sm"
                        style={{ width: '100px' }}
                        value={original.get_hold_status}
                        onChange={e =>
                            handleHoldStatusChange(e, original.hold_id, original.rx_id)
                        }
                    >
                        <option value="1">Hold</option>
                        <option value="0">Unhold</option>
                    </Form.Select>
                </div>
            )
        },
        {
            accessorKey: 'hold_type',
            header: 'Hold Type',
            meta: {
                headerProps: { className: 'text-900 ' }
            }
        },
        // {
        //     accessorKey: 'hold_by_username', header: 'Hold By',
        //     meta: {
        //         headerProps: { className: 'text-900 text-start' },
        //         cellProps: { className: 'text-start' }
        //     },
        // },
        {
            accessorKey: 'hold_by_date',
            header: 'Hold Date',
            meta: {
                headerProps: { className: 'text-900' }
            },
            sortingFn: (rowA, rowB) => {
                const a =
                    rowA.original.hold_by_date !== '-'
                        ? moment(rowA.original.hold_by_date, 'MM/DD/YY')
                        : moment(0);
                const b =
                    rowB.original.hold_by_date !== '-'
                        ? moment(rowB.original.hold_by_date, 'MM/DD/YY')
                        : moment(0);
                return a.isBefore(b) ? -1 : a.isAfter(b) ? 1 : 0;
            },
            cell: ({ row: { original } }) =>
                original.hold_by_username !== '-' ? (
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip id={`tooltip-holdby-${original.hold_id}`}>
                                By: {original.hold_by_username}
                            </Tooltip>
                        }
                    >
                        <span
                            style={{ cursor: 'pointer', textDecoration: 'underline dotted' }}
                        >
                            {original.hold_by_date}
                        </span>
                    </OverlayTrigger>
                ) : (
                    <span>{original.hold_by_date}</span>
                )
        },
        // {
        //     accessorKey: 'called_date_reason',
        //     header: 'Called Date/Reason',
        //     meta: {
        //         headerProps: { className: 'text-900 text-start' },
        //         cellProps: { className: 'text-start' }
        //     },
        //     cell: ({ row: { original } }) => {
        //         const text = original.called_date_reason;
        //         const isTruncated = text && text !== '-' && text.length > 30;
        //         return isTruncated ? (
        //             <span
        //                 title={text}
        //                 style={{ cursor: 'pointer', color: '#2c7be5' }}
        //                 onClick={() => {
        //                     setCalledReasonFull(text);
        //                     setShowCalledReasonModal(true);
        //                 }}
        //             >
        //                 {truncateText(text)}
        //             </span>
        //         ) : (
        //             <span>{text || '-'}</span>
        //         );
        //     }
        // },
        {
            accessorKey: 'action',
            header: 'Actions',
            meta: {
                headerProps: { className: 'text-900 text-center' },
                cellProps: { className: 'text-center' }
            },
            cell: ({ row: { original } }) => (
                <div className="d-flex align-items-center justify-content-center gap-2">
                    {/* <Button
                        variant="outline-primary"
                        size="sm"
                        className="py-0 px-2 fs-10 d-inline-flex align-items-center"
                        onClick={() => handleAddOrderFromHold(original)}
                        title="Add Order"
                    >
                        <FontAwesomeIcon icon="plus" className="me-1" />
                        Add Order
                    </Button> */}
                    <IconItem
                        tag="button"
                        icon={['far', 'edit']}
                        size="sm"
                        onClick={() => handleAddOrderFromHold(original)}
                        className="btn rounded-3 me-2 fs-11 align-items-center"
                    />
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id={`tooltip-notes-${original.hold_id}`}>View Notes</Tooltip>}
                    >
                        <FontAwesomeIcon
                            icon="eye"
                            tag="button"
                            className={original.notes.length > 0 ? "cursor-pointer text-success fs-9 ms-1" : "cursor-pointer fs-9 ms-1"}
                            onClick={() => openNotesModal(original.hold_id, original.notes)}
                        />
                    </OverlayTrigger>
                </div>
            )
        }
    ];

    const handleSearchClick = () => {
        setStartDateError('');
        setEndDateError('');

        if (!startDate || !endDate) {
            if (!startDate) setStartDateError('Start Date is required.');
            if (!endDate) setEndDateError('End Date is required.');
            return;
        }
        fetchHoldData();
    };

    const handleStartDateChange = date => {
        setStartDate(date);
        setStartDateError('');
    };

    const handleEndDateChange = date => {
        setEndDate(date);
        setEndDateError('');
    };

    const fetchHoldData = async () => {
        if (!startDate || !endDate) {
            if (!startDate) setStartDateError('Start Date is required.');
            if (!endDate) setEndDateError('End Date is required.');
            return;
        }
        setStartDateError('');
        setEndDateError('');
        setIsLoading(true);
        const groupList = JSON.parse(localStorage.getItem('groupsData'));

        setOptions([{ key: 'All facilities', value: '' }, ...facilityResultsNew]);
        let temp = {};
        const groupResults = groupList.map(group => {
            const facilitiesForGroup = facilityResultsNew.filter(
                facility => facility.group_id === group.value
            );

            temp[group.value] = facilitiesForGroup.map(facility => ({
                name: facility.key,
                id: facility.value
            }));

            return { key: group.key, value: group.value };
        });

        setGroupOptions([{ key: 'All Groups', value: '' }, ...groupResults]);
        setFacilityObj(temp);
        const facilitiesMap = facilityResultsNew.reduce((acc, facility) => {
            acc[facility.value] = facility.key;
            return acc;
        }, {});
        setFacilitiesObj(facilitiesMap);
        try {
            const token = localStorage.getItem('accessToken');
            const payload = {
                start_date: moment(startDate).subtract(365, 'days').format('YYYY-MM-DD'),
                end_date: moment(endDate).add(365, 'days').format('YYYY-MM-DD')
            };

            const { data } = await axios.post(
                `${process.env.REACT_APP_SERVER_URL}/drugs/list-hold-drug/`,
                payload,
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            const reasons = await axios.get(
                `${process.env.REACT_APP_SERVER_URL}/drugs/list-hold-reasons/`,
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            );
            let reasonsResults = [];
            const getReasonsList = reasons.data.hold_reasons.data;
            if (getReasonsList.length > 0) {
                getReasonsList.forEach(val => {
                    if (val.is_active == 1) {
                        reasonsResults.push({
                            key: val.reason,
                            value: val.id
                        });
                    }
                });

                setReasonsOptions([
                    { key: 'All Reasons', value: '' },
                    ...reasonsResults
                ]);
                setReasonsResults(reasonsResults);
            }
            const reasonMap = {};
            reasons.data.hold_reasons.data.forEach(r => {
                reasonMap[r.id] = r.reason;
            });
            setReasonObj(reasonMap);

            const formattedData = data.drug_hold.data.map(item => ({
                hold_id: item.id,
                facility_id: item.facility_id,
                facility:
                    facilityList.find(f => f.value === item.facility_id)?.key || '',
                delivery_cycle_date: item.due_date
                    ? moment(item.due_date).format('MM/DD/YY')
                    : '',
                patient: `${item.patient_lastname}, ${item.patient_firstname}`,
                patient_id: item.patient_id,
                external_patient_id: item.external_patient_id,
                patient_firstname: item.patient_firstname,
                patient_lastname: item.patient_lastname,
                rx_id: item.pharmacy_order_id,
                drug: item.drug,
                reason:
                    item.holdreason_id != 0
                        ? reasonMap[item.holdreason_id] || ''
                        : item.holdreason_text,
                get_hold_status: item.is_hold,
                hold_type: item.is_cycle === 1 ? 'Cycle' : 'Daily',
                hold_by_date: item.is_hold
                    ? `${moment(item.hold_date).format('MM/DD/YY')}`
                    : '-',
                raw_hold_date: item.hold_date,
                raw_due_date: item.due_date,
                hold_by_username: item.is_hold ? `${item.hold_by_username}` : '-',
                called_date_reason: item.is_called
                    ? `${item.called_by_username} ${moment(item.called_date).format(
                        'MM/DD/YY'
                    )} ${item.called_note}`
                    : '-',
                get_called_reason: item.called_note || '',
                get_called_username: item.called_by_username || '',
                get_called_date: item.called_date || '',
                store_id: item.store_id,
                notes: item.notes
            }));
            const results = formattedData.filter(
                item => Number(item.get_hold_status) == 1
            );

            setData(formattedData);
            setFilteredData(results);
            applyFilters(formattedData);
        } catch (error) {
            toast.error('Error fetching hold data');
        } finally {
            setIsLoading(false);
        }
    };

    const handleHoldStatusChange = async (e, holdId, rxId) => {
        const newStatus = e.target.value;
        const token = localStorage.getItem('accessToken');
        const payload = { hold_id: holdId, is_hold: newStatus };

        const { data: response } = await axios.post(
            `${process.env.REACT_APP_SERVER_URL}/drugs/update-hold-status/`,
            payload,
            {
                headers: { Authorization: `Bearer ${token}` }
            }
        );

        if (response.status) {
            toast.success(`Rx ${rxId} updated successfully`);

            // Update status in both data and filteredData
            setData(prevData =>
                prevData.map(item =>
                    item.hold_id === holdId
                        ? { ...item, get_hold_status: newStatus }
                        : item
                )
            );

            setFilteredData(prevFiltered =>
                prevFiltered.map(item =>
                    item.hold_id === holdId
                        ? { ...item, get_hold_status: newStatus }
                        : item
                )
            );
        }
    };

    const openNotesModal = (id, notes) => {
        setHoldId(id);
        setHoldNotes(notes || []);
        setShowModal(true);
    };

    const handleNotesUpdate = (id, updatedNotes) => {
        setData(prevData =>
            prevData.map(item =>
                item.hold_id === id ? { ...item, notes: updatedNotes } : item
            )
        );

        setFilteredData(prevFiltered =>
            prevFiltered.map(item =>
                item.hold_id === id ? { ...item, notes: updatedNotes } : item
            )
        );

        setHoldNotes(updatedNotes || []);
    };

    const openRxModal = () => {
        setShowRxModal(true);
    };

    const applyFilters = formattedData => {
        let filtered = formattedData || [...data];

        if (dateFilterType !== 'all' && startDate && endDate) {
            const start = moment(startDate).startOf('day');
            const end = moment(endDate).endOf('day');
            filtered = filtered.filter(item => {
                const targetDateStr = dateFilterType === 'hold_date' ? item.raw_hold_date : item.raw_due_date;
                if (!targetDateStr) return false;
                const mDate = moment(targetDateStr);
                if (!mDate.isValid()) return false;
                return mDate.isSameOrAfter(start) && mDate.isSameOrBefore(end);
            });
        }

        if (filters.facility) {
            const selectedFacilityObj = facilityList.find(f => String(f.value) === String(filters.facility));
            const facilityName = selectedFacilityObj?.key;
            filtered = filtered.filter(
                item => String(item.facility_id) === String(filters.facility) || item.facility === facilityName
            );
        } else if (filters.group) {
            const groupFacilities = facilityList.filter(f => String(f.group_id) === String(filters.group));
            const groupFacilityIds = groupFacilities.map(f => String(f.value));
            const groupFacilityNames = groupFacilities.map(f => f.key);
            filtered = filtered.filter(
                item => groupFacilityIds.includes(String(item.facility_id)) || groupFacilityNames.includes(item.facility)
            );
        }

        if (filters.holdreason) {
            filtered = filtered.filter(
                item => item.reason === reasonObj[filters.holdreason]
            );
        }
        if (filters.holdstatus) {
            filtered = filtered.filter(
                item => Number(item.get_hold_status) === Number(filters.holdstatus)
            );
        }
        if (filters.holdtype) {
            filtered = filtered.filter(
                item =>
                    item.hold_type === (filters.holdtype === '1' ? 'Cycle' : 'Daily')
            );
        }
        if (filters.holdsearch) {
            const term = filters.holdsearch.toLowerCase().trim();
            filtered = filtered.filter(
                item =>
                    (item.patient && item.patient.toLowerCase().includes(term)) ||
                    (item.facility && item.facility.toLowerCase().includes(term)) ||
                    (item.rx_id && String(item.rx_id).toLowerCase().includes(term)) ||
                    (item.drug && item.drug.toLowerCase().includes(term))
            );
        }
        if (filters.store) {
            filtered = filtered.filter(
                item => Number(item.store_id) === Number(filters.store)
            );
        }
        if (filters.delivery_cycle_date) {
            filtered = filtered.filter(item =>
                moment(item.delivery_cycle_date).isSame(
                    filters.delivery_cycle_date,
                    'day'
                )
            );
        }
        if (filters.hold_by_date) {
            filtered = filtered.filter(item =>
                item.raw_hold_date &&
                moment(item.raw_hold_date).isSame(filters.hold_by_date, 'day')
            );
        }
        setFilteredData(filtered);
    };

    const handleFilterChange = e => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    const handleStoreFilterChange = e => {
        setSelectedStoreValue(e);
        const value = e ? e.value : '';
        setStoredStoreId(value);
        setFilters(prev => ({ ...prev, store: value }));
    };

    const handleSelectChange = (field, selected) => {
        setFilters(prev => ({ ...prev, [field]: selected?.value || '' }));
    };

    const {
        config: { isNavbarVerticalCollapsed },
        setConfig
    } = useAppContext();

    useEffect(() => {
        setConfig('isNavbarVerticalCollapsed', true);
        try {
            SetMastersDetails();
        } catch (e) {
            console.error("SetMastersDetails error:", e);
        }
        fetchHoldData();
        return () => {
            setConfig('isNavbarVerticalCollapsed', isNavbarVerticalCollapsed);
            RemoveMasters();
        };
    }, []);

    useEffect(() => {
        applyFilters();
    }, [filters, dateFilterType]);

    const handleGroupChange = selected => {
        setSelectedGroupValue(selected || { key: 'All Groups', value: '' });
        setSelectedFacilityValue({ key: 'All Facilities', value: '' });
        const groupVal = selected ? selected.value : '';

        if (groupVal !== '') {
            const groupFacilities = facilityResultsNew.filter(
                facility => String(facility.group_id) === String(groupVal)
            );
            const groupFacilityResults = groupFacilities.map(facility => ({
                key: facility.key,
                value: facility.value
            }));
            setOptions([
                { key: 'All Facilities', value: '' },
                ...groupFacilityResults
            ]);
        } else {
            setOptions([
                { key: 'All Facilities', value: '' },
                ...facilityResultsNew
            ]);
        }

        setFilters(prev => ({
            ...prev,
            group: groupVal,
            facility: ''
        }));
    };

    const handleFacilityChange = selected => {
        setSelectedFacilityValue(selected || { key: 'All Facilities', value: '' });
        const facilityVal = selected ? selected.value : '';
        setFilters(prev => ({
            ...prev,
            facility: facilityVal
        }));
    };

    const table = useAdvanceTable({
        data: filteredData,
        columns,
        selection: false,
        sortable: true,
        pagination: true
    });

    const breadcrumbItems = [
        { name: 'Dashboard', href: '/main', isActive: false },
        { name: 'Order-Hold', href: paths.indexHold, isActive: true }
    ];

    return (
        <>
            <CommonBreadCrumb breadcrumbItems={breadcrumbItems} />
            <Card className="p-3 mb-3">
                <Row className="align-items-end g-3">
                    <Col lg={2} md={3} sm={6}>
                        <Form.Group>
                            <Form.Label className="fw-medium text-700">Filter Date By</Form.Label>
                            <Form.Select
                                value={dateFilterType}
                                onChange={e => setDateFilterType(e.target.value)}
                            >
                                <option value="hold_date">Hold Date</option>
                                <option value="due_date">Delivery/Cycle Date</option>
                                <option value="all">All Records (No Date Filter)</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col lg={3} md={4} sm={6}>
                        <Form.Group>
                            <Form.Label className="fw-medium text-700">Start Date</Form.Label>
                            <DatePicker
                                selected={startDate}
                                onChange={handleStartDateChange}
                                dateFormat="MM/dd/yy"
                                className="form-control"
                            />
                            {startDateError && (
                                <div className="text-danger fs-10 mt-1">{startDateError}</div>
                            )}
                        </Form.Group>
                    </Col>
                    <Col lg={3} md={4} sm={6}>
                        <Form.Group>
                            <Form.Label className="fw-medium text-700">End Date</Form.Label>
                            <DatePicker
                                selected={endDate}
                                onChange={handleEndDateChange}
                                dateFormat="MM/dd/yy"
                                className="form-control"
                            />
                            {endDateError && (
                                <div className="text-danger fs-10 mt-1">{endDateError}</div>
                            )}
                        </Form.Group>
                    </Col>
                    <Col lg={4} md={12} className="d-flex align-items-center justify-content-start gap-2 mt-3 mt-lg-0">
                        <Button
                            variant="primary"
                            onClick={handleSearchClick}
                            disabled={!startDate || !endDate}
                        >
                            <FontAwesomeIcon icon="search" className="me-1" /> Search
                        </Button>
                        <Button
                            variant="outline-secondary"
                            onClick={() => setShowFilterDrawer(true)}
                            className="d-inline-flex align-items-center"
                        >
                            <FontAwesomeIcon icon="filter" className="me-1" />
                            Filters
                            {activeFilterCount > 0 && (
                                <Badge bg="primary" pill className="ms-1 fs-11">
                                    {activeFilterCount}
                                </Badge>
                            )}
                        </Button>
                        <Button
                            variant="warning"
                            onClick={openRxModal}
                            className="ms-auto fw-bold shadow-sm d-inline-flex align-items-center px-3"
                        >
                            <FontAwesomeIcon icon="pause-circle" className="me-1" />
                            Hold Rx
                        </Button>
                    </Col>
                </Row>
            </Card>

            <Offcanvas
                show={showFilterDrawer}
                onHide={() => setShowFilterDrawer(false)}
                placement="end"
                style={{ width: '380px' }}
            >
                <Offcanvas.Header closeButton className="border-bottom bg-body-tertiary">
                    <Offcanvas.Title className="fs-9 fw-bold">
                        <FontAwesomeIcon icon="filter" className="me-2 text-primary" /> Filter Options
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="p-4">
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-medium text-700">Search</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Search patient, facility, Rx #, drug"
                                name="holdsearch"
                                value={filters.holdsearch}
                                onChange={handleFilterChange}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="fw-medium text-700">Group</Form.Label>
                            <ThemedSelect
                                name="group"
                                placeholder="Select Group"
                                options={groupOptions}
                                value={selectedGroupValue}
                                classNamePrefix="react-select"
                                getOptionLabel={option => option.key}
                                getOptionValue={option => option.value}
                                onChange={handleGroupChange}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="fw-medium text-700">Facility</Form.Label>
                            <ThemedSelect
                                name="facility"
                                placeholder="Select Facility"
                                options={options}
                                value={selectedFacilityValue}
                                classNamePrefix="react-select"
                                getOptionLabel={option => option.key}
                                getOptionValue={option => option.value}
                                onChange={handleFacilityChange}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="fw-medium text-700">Store</Form.Label>
                            <ThemedSelect
                                name="store"
                                closeMenuOnSelect={true}
                                classNamePrefix="react-select"
                                options={storeOptions}
                                value={selectedStoreValue}
                                getOptionLabel={option => option.key}
                                getOptionValue={option => option.value}
                                onChange={e => handleStoreFilterChange(e)}
                                styles={{
                                    control: provided => ({
                                        ...provided,
                                        borderColor: '#ced4da',
                                        boxShadow: 'none',
                                        '&:hover': { borderColor: '#80bdff' }
                                    }),
                                    option: (provided, { isFocused, isSelected }) => ({
                                        ...provided,
                                        backgroundColor: isSelected
                                            ? '#e9ecef !important'
                                            : isFocused
                                                ? '#f8f9fa !important'
                                                : 'white !important',
                                        color: '#212529 !important',
                                        cursor: 'pointer'
                                    }),
                                    singleValue: provided => ({
                                        ...provided,
                                        color: '#212529'
                                    })
                                }}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="fw-medium text-700">Hold Status</Form.Label>
                            <Form.Select
                                name="holdstatus"
                                value={filters.holdstatus}
                                onChange={handleFilterChange}
                            >
                                <option value="">All</option>
                                <option value="1">Hold</option>
                                <option value="0">Unhold</option>
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="fw-medium text-700">Hold Type</Form.Label>
                            <Form.Select
                                name="holdtype"
                                value={filters.holdtype}
                                onChange={handleFilterChange}
                            >
                                <option value="">All</option>
                                <option value="1">Cycle</option>
                                <option value="0">Daily</option>
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="fw-medium text-700">Hold Reason</Form.Label>
                            <ThemedSelect
                                name="holdreason"
                                placeholder="Select Reason"
                                options={reasonOptions}
                                classNamePrefix="react-select"
                                getOptionLabel={option => option.key}
                                getOptionValue={option => option.value}
                                onChange={selected =>
                                    handleSelectChange('holdreason', selected)
                                }
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="fw-medium text-700">Hold Date</Form.Label>
                            <DatePicker
                                selected={
                                    filters.hold_by_date
                                        ? moment(filters.hold_by_date).toDate()
                                        : null
                                }
                                onChange={date =>
                                    setFilters(prev => ({
                                        ...prev,
                                        hold_by_date: date
                                            ? moment(date).format('YYYY-MM-DD')
                                            : ''
                                    }))
                                }
                                dateFormat="MM/dd/yy"
                                className="form-control w-100"
                                placeholderText="Filter by Hold Date"
                            />
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Label className="fw-medium text-700">Delivery Date</Form.Label>
                            <DatePicker
                                selected={
                                    filters.delivery_cycle_date
                                        ? moment(filters.delivery_cycle_date).toDate()
                                        : null
                                }
                                onChange={date =>
                                    setFilters(prev => ({
                                        ...prev,
                                        delivery_cycle_date: date
                                            ? moment(date).format('YYYY-MM-DD')
                                            : ''
                                    }))
                                }
                                dateFormat="MM/dd/yy"
                                className="form-control w-100"
                                placeholderText="Filter by Delivery Date"
                            />
                        </Form.Group>

                        <div className="d-flex justify-content-between gap-2 border-top pt-3">
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                onClick={handleResetFilters}
                            >
                                Reset Filters
                            </Button>
                            <Button
                                variant="primary"
                                size="sm"
                                onClick={() => setShowFilterDrawer(false)}
                            >
                                Apply & Close
                            </Button>
                        </div>
                    </Form>
                </Offcanvas.Body>
            </Offcanvas>
            {isLoading ? (
                <ShimmerUI />
            ) : filteredData.length === 0 ? (
                <Alert variant="info" className="text-center fw-bold">
                    No hold data found for the selected filters or date range.
                </Alert>
            ) : (
                <Card className="p-3">
                    <AdvanceTableProvider {...table}>
                        <Row>
                            <Col>
                                <AdvanceTable
                                    headerClassName="bg-200 text-nowrap align-middle text-center"
                                    rowClassName="text-nowrap align-middle text-center"
                                    tableProps={{
                                        size: 'sm',
                                        striped: true,
                                        className: 'fs-10 mb-0 overflow-hidden'
                                    }}
                                />
                            </Col>
                        </Row>
                        <div className="mt-3">
                            <AdvanceTableFooter rowInfo navButtons rowsPerPageSelection />
                        </div>
                    </AdvanceTableProvider>
                </Card>
            )}
            <Modal
                show={showRxModal}
                onHide={() => setShowRxModal(false)}
                size="xl"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title className="fs-8">Hold Rx</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    {showRxModal && (
                        <HoldRxGrid holdreasonsdata={holdreasonsresults} modalMode />
                    )}
                </Modal.Body>
            </Modal>
            <AddNotesModal
                show={showModal}
                setShow={setShowModal}
                holdid={holdId}
                notes={holdNotes}
                onNotesUpdate={handleNotesUpdate}
            />
            <AddHoldOrderDetailModal
                show={showCreateOrderModal}
                setShow={setShowCreateOrderModal}
                initialData={createOrderInitialData}
                patientId={createOrderInitialData?.patient_id}
                patientName={createOrderInitialData?.patient_name}
                facilityId={createOrderInitialData?.facility_id}
                facilityName={createOrderInitialData?.facility_name}
                onSuccess={fetchHoldData}
            />
        </>
    );
};

export default IndexHold;
